import React from "react";
import PropTypes from "prop-types";
import { HISTORIC_GUARDIAN_BOND } from "../historicGuardianConfig";
import HistoricGuardianFormBase from "./HistoricGuardianFormBase";
import GoogleAutoComplete from "./TrusteeHistoricGoogleAutoComplete";
import LabeledCreatableSelect from "./TrusteeHistoricLabeledCreatableSelect";
import { scrollToTop } from "../../../../features/bonds/shared/formHelpers";

export default function TrusteeHistoricGuardianForm(props) {
  return (
    <HistoricGuardianFormBase
      bondKind={HISTORIC_GUARDIAN_BOND.trustee}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      scrollToTop={scrollToTop}
      {...props}
    />
  );
}

TrusteeHistoricGuardianForm.propTypes = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
};
